import React from 'react';
import HistoryTable from '../History/HistoryTable';

const ReceivedHistory = ({ userID, collectionName }) => {
  // টেবিলের কলামগুলো কী হবে তা এখানে নির্ধারণ করা হয়েছে
  const columns = [
    { key: 'date', label: 'Date & Time' },
    { key: 'amount', label: 'Amount' },
    { key: 'senderId', label: 'From (Sender ID)' },
  ];

  return (
    <HistoryTable
      userID={userID} // বর্তমান ব্যবহারকারীর Auth UID
      collectionName={collectionName} // ব্যবহারকারীর কালেকশন (e.g., 'agencies', 'resellers')
      historyType="receiveHistory" // Firestore-এর সাব-কালেকশনের নাম
      title="Received History" // টেবিলের শিরোনাম
      columns={columns} // টেবিলের কলামের কনফিগারেশন
      searchField="senderId" // কোন ফিল্ডের উপর ভিত্তি করে সার্চ করা হবে
    />
  );
};

export default ReceivedHistory;